






































import { Vue, Component, Prop, Mixins, Watch } from 'vue-property-decorator';
import GImportModal from '@/components/GImportModal.vue';
import { schoolClassModule } from '@/store/modules/entities/school-class.module';
import { GEnum } from '@/constants/enum.defination';
import { GPageBase } from '@/mixins';
import * as XLSX from 'xlsx';
import { importModalModule } from '@/store/modules/frames/import-modal.module';

@Component({
  name: 'GClassImport',
  components: { GImportModal },
  computed: {},
  methods: {},
})
export default class GClassImport extends Mixins(GPageBase) {
  showClassImportModal: boolean = false;
  entryCount: number = 0;
  updateCount: number = 0;
  showConfirmModal: boolean = false;

  @Prop() value: boolean;

  @Watch('value')
  openModal(value: boolean) {
    this.showClassImportModal = value;
  }

  @Watch('showClassImportModal')
  close(value: boolean) {
    this.$emit('input', value);
  }

  handleClassTemplateDownload() {
    schoolClassModule.downloadRegistrationTemplate().then(() => {
      importModalModule.setIsDownloading(false);
    });
  }

  handleClassUpload(workBook: XLSX.WorkBook) {
    // 多言語化対応 : インポート用のエクセルのシート名も多言語対応するのか (2023-11)
    // this.entryCount = XLSX.utils.sheet_to_json(workBook.Sheets[this.$t('SCHOOL_CLASS_ADD_SHEET_NAME').toString()]).length;
    // this.updateCount = XLSX.utils.sheet_to_json(workBook.Sheets[this.$t('SCHOOL_CLASS_UPDATE_SHEET_NAME').toString()]).length;
    this.entryCount = XLSX.utils.sheet_to_json(workBook.Sheets['クラス登録用シート']).length;
    this.updateCount = XLSX.utils.sheet_to_json(workBook.Sheets['クラス更新用シート']).length;
    this.showConfirmModal = true;
  }

  handleOK(formData: FormData) {
    schoolClassModule
      .postSchoolClassFile(formData)
      .then((response: any) => {
        this.showConfirmModal = false;
        if (response) {
          let messages: string[] = [];
          if (response.data.registrationCount > 0) {
            messages.push(`${this.$t('REGISTRATION_COUNT').toString()}：${response.data.registrationCount}${this.$t('UNIT.COUNT').toString()}`);
          }
          if (response.data.updatedCount > 0) {
            messages.push(`${this.$t('REGISTRATION_COUNT').toString()}：${response.data.updatedCount}${this.$t('UNIT.COUNT').toString()}`);
          }

          // Success notice
          this.showNotice(GEnum.MessageType.Success, this.$t('NOTICE.TITLE.UPDATE_COMPLETED').toString(), messages.join('<br/>'), 10);

          // close dialog
          this.$emit('input', false);

          this.isRunning = true;
          this.lazyAction(() => {
            this.isRunning = false;
            window.location.reload();
          }, 5000);
        }
      })
      .finally(() => {
        importModalModule.setIsUploading(false);
      });
  }
}
